import styled from 'styled-components';

const BlockDescription = styled.div`
  max-width: 470px;
`;

export { BlockDescription };
